import { SOCKET_URL } from 'shared/constants/urls'
import { io } from 'socket.io-client'

const socket = io(SOCKET_URL, {
  autoConnect: false,
  transports: ['websocket']
})

export default socket
